import { Global } from '../Global';
import { Order } from '../models/OrderContract';
import { post } from '../utils/ApiUtil';

export interface CreateOrderParams {
  productId: string;
  quantity: number;
  specificationType?: number;
}

export interface PreparePayParams {
  orderId: string;
  payScene?: string;
  returnUrl?: string;
  quitUrl?: string;
}

export interface PreparePayResult {
  payScene: string;
  orderId: string;
  payAmountYuan: number;
  checkoutCredentialType?: string;
  redirectUrl?: string;
}

const createOrder = async (params: CreateOrderParams): Promise<Order | null> => {
  if (Global.isMockMode()) {
    return Global.getMockData('createOrder') as Order | null;
  }
  const result = await post<CreateOrderParams, Order>('/order/createOrder', params);
  if (typeof result === 'string') {
    return null;
  }
  return result;
};

const preparePay = async (params: PreparePayParams): Promise<PreparePayResult | null> => {
  if (Global.isMockMode()) {
    return Global.getMockData('preparePay') as PreparePayResult | null;
  }
  const result = await post<PreparePayParams, PreparePayResult>('/order/preparePay', {
    payScene: 'web_page',
    ...params,
  });
  if (typeof result === 'string') {
    return null;
  }
  return result;
};

/** 待支付订单跳转 Web 收银台；成功时会整页跳转 */
const startWebOrderPay = async (orderId: string): Promise<{ ok: true } | { ok: false; message: string }> => {
  const id = orderId?.trim();
  if (!id) {
    return { ok: false, message: '订单号无效' };
  }
  const returnUrl = `${window.location.origin}${window.location.pathname}#/order-contract`;
  const prep = await preparePay({
    orderId: id,
    payScene: 'web_page',
    returnUrl,
    quitUrl: window.location.href,
  });
  const redirect = prep?.redirectUrl?.trim();
  if (!redirect) {
    return { ok: false, message: '未获取到收银台地址' };
  }
  window.location.href = redirect;
  return { ok: true };
};

export const OrderApi = {
  createOrder,
  preparePay,
  startWebOrderPay,
};
